import $ from 'jquery';

//Constants
var selectorError = '.erreurJauge',
    selectorActivationMsg = '.activationMsg',
    selectorGlobalSection = '.tableau_main',
    selectorJaugeContainer='.jaugeContainer',
    selectorJaugeMaster = '.jaugemaster',
    selectorStaticContext = "#jauge-static-context",
    attrStaticContext= "data-file-context",
    selectorLoaderTdb = '#loader_tdb',
    selectorImg="#tdb_image",
    selectorErrorIndispo = '.erreurIndispo',
    MIN_INDEX = 0,
    MAX_INDEX = 100,
    PATH_IMG = '/Resources/img/jauges/jauge_tdb_',
    MOBILE_BREAKPOINT = 768;

//Elements Jquery
var $errorMsg = null,
    $errorMsgIndispo = null,
    $jaugeMaster = null,
    $jaugeContainer = null,
    $loaderTdb = null,
    $img = null,
    $globalSection = null,
    $activationMsg = null,
    $staticContext = null;

/*
    Show a message when it's the first time that the Jauge is shown to a user
 */

/* 2747 - COMMENT FIRST ACCESS JAUGE PARCOURS

SESSION_FIST_TIME = "jauge_first_time",
isFirstAccesFlag = false;
selectorFirst = '.sansJaugeFirst',
selectorFirst2 = '.sansJaugeFirst2',
$firstMsg = null,
$firstMsg2 = null,

function showFirstTime(){
    $jaugeContainer.hide();
    $loaderTdb.hide();
    $firstMsg.show();
    window.localStorage.setItem(SESSION_FIST_TIME, "true");
}
*/

/*
    Show active jauge
 */
function showJaugeActive(index){
    var type = '';
    var nb = Math.ceil(index * 43 / 100);
    if (index >= 1 && index <= 30) {
        type = 'orange_';
    }

    $img.removeAttr( 'src' )
        .attr( 'src' , $staticContext + PATH_IMG + type + nb + '.png');

    $jaugeMaster.show();
}

/*
    Show section of inactive jauge
 */
function showJaugeInactive(){
    $activationMsg.show();
}

/*
    Show error Msg when service aren't unable
 */
function showError(){
    $errorMsg.show();
    $errorMsgIndispo.show();
    $jaugeContainer.show();
}

/*
    Display jauge with data
 */
function displayJauge(index) {
    if (index >= MIN_INDEX && index <= MAX_INDEX) {
        showJaugeActive(index);
    } else {
        showJaugeInactive();
    }
    $jaugeContainer.show();
}

function errorOccurred(responseJSON){
    return responseJSON == undefined ||
        responseJSON.commun == undefined ||
        responseJSON.commun.statut == undefined;
}

function getJaugeInfo(){
    //var url  = $staticContext + '/Resources/Configuration/jauge_info.json';
    //var responseJSON = JSON.parse(responseJSONString);

    var contentType = 'multipart/form-data';
    var url = '/abm/restit/perso/meteo2.json';

    // remove loader after delay
    $loaderTdb.delay(3000).hide(0);

    $.ajax({
        url: url,
        contentType: contentType,
        success: function success(responseJSON) {
            $loaderTdb.hide();

            // If basic variables from response are wrong or status is nok
            if (errorOccurred(responseJSON)
            || (responseJSON.commun.statut == "nok")) {
                $globalSection.hide();
                return;
            }

            // if we have a raison with no personnalisation, display the corresponding msg
            if ((typeof responseJSON.commun.raison !== "undefined") &&
                (responseJSON.commun.raison == "pas_perso" || responseJSON.commun.raison == "aucune_perso")){
               showJaugeInactive();

            // if it should work but we don't have any data, display an error
            } else if (responseJSON.donnees == undefined || responseJSON.donnees.indexCav == undefined) {
                showError();

            // then display the jauge
            } else {
                displayJauge(responseJSON.donnees.indexCav);
            }
        },
        error : function() {
            $loaderTdb.hide();
            $globalSection.hide();
        }
    });
}

var initJauge = function initJauge() {
    if ($(window).width() > MOBILE_BREAKPOINT) {
        return;
    }

    $loaderTdb = $(selectorLoaderTdb);
    $loaderTdb.show();
    $jaugeContainer = $(selectorJaugeContainer);
    $jaugeMaster = $(selectorJaugeMaster);
    $img=$(selectorImg);
    $globalSection=$(selectorGlobalSection);
    $activationMsg = $(selectorActivationMsg);

    $errorMsg = $(selectorError);
    $errorMsgIndispo = $(selectorErrorIndispo);

    // get path context of img
    $staticContext = $(selectorStaticContext).attr(attrStaticContext);

    getJaugeInfo();
};

export {initJauge};


// WEBPACK FOOTER //
// ./src/js/cms/pri/initJauge.js